function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#1CA2E1",
  fillRule: "evenodd",
  d: "M14.009 12l6.57-6.571a1.42 1.42 0 10-2.008-2.012L12 9.987l-6.571-6.57a1.422 1.422 0 10-2.012 2.012L9.987 12l-6.57 6.571a1.422 1.422 0 102.012 2.012L12 14.013l6.571 6.57a1.422 1.422 0 102.012-2.012L14.01 12z"
});

var SvgCloseSlide = function SvgCloseSlide(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiMxQ0EyRTEiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjAwOSAxMmw2LjU3LTYuNTcxYy41NTYtLjU1NS41NTctMS40NTUuMDAyLTIuMDEtLjU1NC0uNTU2LTEuNDU0LS41NTctMi4wMS0uMDAyTDEyIDkuOTg3bC02LjU3MS02LjU3Yy0uNTU2LS41NTYtMS40NTctLjU1Ni0yLjAxMiAwLS41NTYuNTU1LS41NTYgMS40NTYgMCAyLjAxMkw5Ljk4NyAxMmwtNi41NyA2LjU3MWMtLjU1Ni41NTYtLjU1NiAxLjQ1NyAwIDIuMDEyLjU1NS41NTYgMS40NTYuNTU2IDIuMDEyIDBMMTIgMTQuMDEzbDYuNTcxIDYuNTdjLjU1Ni41NTYgMS40NTcuNTU2IDIuMDEyIDAgLjU1Ni0uNTU1LjU1Ni0xLjQ1NiAwLTIuMDEyTDE0LjAxIDEyeiIvPgo8L3N2Zz4K";
export { SvgCloseSlide as ReactComponent };